import { apiGet, apiPost, apiPatch } from '@/app/api/core/http';
import { CAT_TRADEMARKS, CAT_NICE_CLASSES } from 'App/utils/Collections';
import { TRADEMARKS_PATHS } from './paths';

export const trademarksApiAdapter = {
  getTrademarks: (params, cat, headers) => {
    let preparedParams = {
      is_protected: true,
    };
    if (params) {
      preparedParams.params = params;
    }
    if (headers) {
      preparedParams.headers = headers.headers;
      preparedParams.headers['cache-control'] = 'no-cache';
    }
    return apiGet(TRADEMARKS_PATHS.trademarks + TRADEMARKS_PATHS.suffix, preparedParams);
  },
  getTrademarksDetails: (id, headers) => {
    if (headers) {
      return apiGet(`${TRADEMARKS_PATHS.trademarks}/${id}`, {
        headers: headers,
        is_protected: true,
      });
    } else {
      return apiGet(`${TRADEMARKS_PATHS.trademarks}/${id}`, { is_protected: true });
    }
  },
  getTrademarksSuggestions: (companyID, params) =>
    apiGet(`${TRADEMARKS_PATHS.trademarks}/suggestions`, { params: { company: companyID, ...(params || {}) } }),

  getTrademarkHistory: (id) => apiGet(`${TRADEMARKS_PATHS.trademarks}/${id}/history`),
  getTrademarkSnapshotById: (id, snapshot_id) =>
    apiGet(`${TRADEMARKS_PATHS.trademarks}/${id}/history/snapshots/${snapshot_id}`),

  [CAT_TRADEMARKS]: {
    create: (data) => apiPost(TRADEMARKS_PATHS.trademarks, { data, is_protected: true }),
    update: (id, data) => apiPatch(`${TRADEMARKS_PATHS.trademarks}/${id}`, { data, is_protected: true }),
  },
  [CAT_NICE_CLASSES]: {
    getList: (params) => apiGet(TRADEMARKS_PATHS.niceClasses, { params }),
  },

  trademarkHolders: {
    getList: (params) => apiGet(TRADEMARKS_PATHS.holders + TRADEMARKS_PATHS.suffix, { params }),
  },
  trademarkRepresentatives: {
    getList: (params) => apiGet(TRADEMARKS_PATHS.representatives + TRADEMARKS_PATHS.suffix, { params }),
  },
  trademarkCorrespondenceAddresses: {
    getList: (params) => apiGet(TRADEMARKS_PATHS.correspondenceAddresses, { params }),
  },
  trademark: {
    loadOffices: async (params) => apiGet(TRADEMARKS_PATHS.offices, { params }),
  },
};

export const trademarksFilterAdapter = {
  getTrademarkStatuses: (params) => apiGet(TRADEMARKS_PATHS.statuses, { params }),
};
